<template>
  <b-modal v-model="showModal" v-if="isReadyToShow" title="Add/Edit Device Config" scrollable :centered="true"
    height="900">
    <div v-if="!formValid" class="alert p-0"><b>{{ errorMessage }}</b></div>
    <b-form ref="form">
      <h5 class="label_1_for_CIDR_CONF mt-20">Select Template to Add filters *</h5>
      <b-form-group label-for="deviceTemplate" invalid-feedback="Please select pexip SDK version.">
        <b-form-select id="deviceTemplate" class="languageWrapperSelect" v-model="addEditDeviceConfig.deviceTemplate"
          style="width: 100%" :options="deviceTemplateList" @change="clearModel()">
        </b-form-select>
      </b-form-group>
      <div class="pageDataWrapper" v-if="addEditDeviceConfig.deviceTemplate === 'BY_FACILITY'">
        <b-card class="card-container-panel">
          <h5 class="label_1_for_CIDR_CONF">By Facility</h5>
          <div class="row m-0 align-items-center">
            <b-form-group label="Facility *" label-for="facility">
              <div class="dropdown p-0">
                <model-select v-model="addEditDeviceConfig.facility" :options="facilityList" name="facility"
                  id="facility" width="600" placeholder="Search/Select Facility" @input="facilitySelected"
                  class="searchableSelect">
                </model-select>
              </div>
            </b-form-group>
          </diV>
          <div class="row m-0 align-items-center">
            <b-form-group label="Unit (Optional)" label-for="unit">
              <div class="dropdown p-0">
                <model-select v-model="addEditDeviceConfig.unit" :options="unitList" name="unit" id="unit" width="600"
                  placeholder="Search/Select Location" @input="unitSelected" class="searchableSelect">
                </model-select>
              </div>
            </b-form-group>
          </div>
          <div class="row m-0 align-items-center">
            <b-form-group label="Area (Optional)" label-for="area">
              <div class="dropdown p-0">
                <model-select v-model="addEditDeviceConfig.area" :options="areaList" name="area" id="area" width="600"
                  placeholder="Search/Select Room" @input="areaSelected" class="searchableSelect">
                </model-select>
              </div>
            </b-form-group>
          </div>
        </b-card>
      </div>
      <div class="pageDataWrapper" v-if="addEditDeviceConfig.deviceTemplate === 'BY_FACILITY_MODEL'">
        <b-card class="card-container-panel">
          <h5 class="label_1_for_CIDR_CONF">By Facility & Device Type</h5>
          <div class="row m-0 align-items-center">
            <b-form-group label="Facility *" label-for="facility">
              <div class="dropdown p-0">
                <model-select v-model="addEditDeviceConfig.facility" :options="facilityList" name="facility"
                  id="facility" width="600" placeholder="Search/Select Facility" @input="facilitySelected"
                  class="searchableSelect">
                </model-select>
              </div>
            </b-form-group>
          </diV>
          <div class="row m-0 align-items-center">
            <b-form-group label="Unit (Optional)" label-for="unit">
              <div class="dropdown p-0">
                <model-select v-model="addEditDeviceConfig.unit" :options="unitList" name="unit" id="unit" width="600"
                  placeholder="Search/Select Location" @input="unitSelected" class="searchableSelect">
                </model-select>
              </div>
            </b-form-group>
          </div>
          <div class="row m-0 align-items-center">
            <b-form-group label="Area (Optional)" label-for="area">
              <div class="dropdown p-0">
                <model-select v-model="addEditDeviceConfig.area" :options="areaList" name="area" id="area" width="600"
                  placeholder="Search/Select Room" @input="areaSelected" class="searchableSelect">
                </model-select>
              </div>
            </b-form-group>
          </div>
          <div class="row m-0 align-items-center">
            <b-form-group label="Device Type *" label-for="deviceType">
              <div class="dropdown p-0">
                <model-select v-model="addEditDeviceConfig.deviceType" :options="deviceTypes" name="deviceType"
                  id="deviceType" width="600" placeholder="Search/Select Device Type" @input="areaSelected"
                  class="searchableSelect">
                </model-select>
              </div>
            </b-form-group>
          </div>
        </b-card>
      </div>
      <div class="pageDataWrapper" v-if="addEditDeviceConfig.deviceTemplate === 'BY_MODEL'">
        <b-card class="card-container-panel">
          <h5 class="label_1_for_CIDR_CONF">By Device Model only</h5>
          <div class="row m-0 align-items-center">
            <b-form-group label="Device Type" label-for="deviceType">
              <div class="dropdown p-0">
                <model-select v-model="addEditDeviceConfig.deviceType" :options="deviceTypes" name="deviceType"
                  id="deviceType" width="600" placeholder="Search/Select Device Type" @input="areaSelected"
                  class="searchableSelect">
                </model-select>
              </div>
            </b-form-group>
          </div>
        </b-card>
      </div>
      <div class="pageDataWrapper" v-if="addEditDeviceConfig.deviceTemplate === 'BY_DEVICE_ID'">
        <b-card class="card-container-panel">
          <h5 class="label_1_for_CIDR_CONF">By DeviceId only</h5>
          <div class="row m-0 align-items-center">
            <b-form-group label="DeviceId" label-for="deviceId">
              <div class="dropdown p-0">
                <model-select v-model="addEditDeviceConfig.deviceId" :options="deviceList" name="deviceId" id="deviceId"
                  width="800" placeholder="Search/Select DeviceId" @input="deviceIdSelected" class="searchableSelect">
                </model-select>
              </div>
            </b-form-group>
          </div>
        </b-card>
      </div>
      <h5 class="label_1_for_CIDR_CONF mt-20">Select Template to add Filter</h5>
      <b-form-group v-slot="{ ariaDescribedby }">
        <b-form-radio-group id="radio-group-1" v-model="addEditDeviceConfig.filterType" :options="filterConfigList"
          :aria-describedby="ariaDescribedby" name="radio-options"></b-form-radio-group>
      </b-form-group>
      <div class="pageDataWrapper" v-if="addEditDeviceConfig.filterType === 'BY_NON_IP_CIDR_ADDR'">
        <b-card class="card-container-panel">
          <h5 class="label_1_for_CIDR_CONF">Configuration 1</h5>
          <div class="row m-0 align-items-center">
            <b-form-group label="Select management server for filter *" label-for="deviceTemplate"
              invalid-feedback="Please select management server for filter">
              <b-form-select id="deviceTemplate" class="languageWrapperSelect"
                v-model="addEditDeviceConfig.deviceFilter.managementNode_1" style="width: 800px"
                :options="managementConfigList" @change="managementNodeSelected('1')">
              </b-form-select>
            </b-form-group>
          </div>
          <div class="row">
            <div class="col">
              <b-form-group label="Select dashboard media node (Optional)" label-for="deviceTemplate"
                invalid-feedback="Please select management server for filter">
                <b-form-select id="dashboardMediaNode_1" class="languageWrapperSelect"
                  v-model="addEditDeviceConfig.deviceFilter.dashboardMediaNode_1" style="width: 100%"
                  :options="addEditDeviceConfig.deviceFilter.mediaNodes_1">
                </b-form-select>
              </b-form-group>
            </div>
            <div class="col">
              <b-form-group label="Select device media node (Optional)" label-for="deviceTemplate"
                invalid-feedback="Please select management server for filter">
                <b-form-select id="deviceMediaNode_1" class="languageWrapperSelect"
                  v-model="addEditDeviceConfig.deviceFilter.deviceMediaNode_1" style="width: 100%"
                  :options="addEditDeviceConfig.deviceFilter.mediaNodes_1">
                </b-form-select>
              </b-form-group>
            </div>
          </div>
        </b-card>
      </div>
      <div class="pageDataWrapper" v-if="addEditDeviceConfig.filterType === 'BY_IP_CIDR_ADDR'">
        <b-card class="card-container-panel">
          <h5 class="label_1_for_CIDR_CONF">Configuration 1</h5>
          <div class="row m-0 align-items-center">
            <b-form-group label="Select management server for filter *" label-for="deviceTemplate"
              invalid-feedback="Please select management server for filter">
              <b-form-select id="deviceTemplate" class="languageWrapperSelect"
                v-model="addEditDeviceConfig.deviceFilter.managementNode_1" style="width: 100%"
                :options="managementConfigList" @change="managementNodeSelected('1')">
              </b-form-select>
            </b-form-group>
          </div>
          <div class="row m-0 align-items-center">
            <b-form-group label="CIDR IP Address" label-for="nodeFilter"
              invalid-feedback="Please enter CIDR IP address.">
              <b-form-input id="cidrIpAdress_1" v-ip-mask
                v-model="addEditDeviceConfig.deviceFilter.cidrIPAddress_1"></b-form-input>
            </b-form-group>
          </div>
          <div class="row m-0 align-items-center">
            <b-form-group label="Select dashboard media node (Optional)" label-for="deviceTemplate"
              invalid-feedback="Please select management server for filter">
              <b-form-select id="dashboardMediaNode_1" class="languageWrapperSelect"
                v-model="addEditDeviceConfig.deviceFilter.dashboardMediaNode_1" style="width: 100%"
                :options="addEditDeviceConfig.deviceFilter.mediaNodes_1">
              </b-form-select>
            </b-form-group>
          </div>
          <div class="row m-0 align-items-center">
            <b-form-group label="Select device media node (Optional)" label-for="deviceTemplate"
              invalid-feedback="Please select management server for filter">
              <b-form-select id="deviceMediaNode_1" class="languageWrapperSelect"
                v-model="addEditDeviceConfig.deviceFilter.deviceMediaNode_1" style="width: 100%"
                :options="addEditDeviceConfig.deviceFilter.mediaNodes_1">
              </b-form-select>
            </b-form-group>
          </div>
        </b-card>
        <br>
        <b-card class="card-container-panel">
          <h5 class="label_1_for_CIDR_CONF">Configuration 2 (Optional)</h5>
          <div class="row m-0 align-items-center">
            <b-form-group label="Select management server for filter *" label-for="deviceTemplate"
              invalid-feedback="Please select management server for filter">
              <b-form-select id="deviceTemplate" class="languageWrapperSelect"
                v-model="addEditDeviceConfig.deviceFilter.managementNode_2" style="width: 100%"
                :options="managementConfigList" @change="managementNodeSelected('2')">
              </b-form-select>
            </b-form-group>
          </div>
          <div class="row m-0 align-items-center">
            <b-form-group label="CIDR IP Address" label-for="nodeFilter"
              invalid-feedback="Please enter CIDR IP address.">
              <b-form-input id="cidrIpAdress_2" v-ip-mask
                v-model="addEditDeviceConfig.deviceFilter.cidrIPAddress_2"></b-form-input>
            </b-form-group>
          </div>
          <div class="row m-0 align-items-center">
            <b-form-group label="Select dashboard media node (Optional)" label-for="deviceTemplate"
              invalid-feedback="Please select management server for filter">
              <b-form-select id="dashboardMediaNode_2" class="languageWrapperSelect"
                v-model="addEditDeviceConfig.deviceFilter.dashboardMediaNode_2" style="width: 100%"
                :options="addEditDeviceConfig.deviceFilter.mediaNodes_2">
              </b-form-select>
            </b-form-group>
          </div>
          <div class="row m-0 align-items-center">
            <b-form-group label="Select device media node (Optional)" label-for="deviceTemplate"
              invalid-feedback="Please select management server for filter">
              <b-form-select id="deviceMediaNode_2" class="languageWrapperSelect"
                v-model="addEditDeviceConfig.deviceFilter.deviceMediaNode_2" style="width: 100%"
                :options="addEditDeviceConfig.deviceFilter.mediaNodes_2">
              </b-form-select>
            </b-form-group>
          </div>
        </b-card>
        <br>
        <b-card class="card-container-panel">
          <h5 class="label_1_for_CIDR_CONF">Configuration 3 (Optional)</h5>
          <div class="row m-0 align-items-center">
            <b-form-group label="Select management server for filter *" label-for="deviceTemplate"
              invalid-feedback="Please select management server for filter">
              <b-form-select id="deviceTemplate" class="languageWrapperSelect"
                v-model="addEditDeviceConfig.deviceFilter.managementNode_3" style="width: 100%"
                :options="managementConfigList" @change="managementNodeSelected('3')">
              </b-form-select>
            </b-form-group>
          </div>
          <div class="row m-0 align-items-center">
            <b-form-group label="CIDR IP Address" label-for="nodeFilter"
              invalid-feedback="Please enter CIDR IP address.">
              <b-form-input id="cidrIpAdress_3" v-ip-mask
                v-model="addEditDeviceConfig.deviceFilter.cidrIPAddress_3"></b-form-input>
            </b-form-group>
          </div>
          <div class="row m-0 align-items-center">
            <b-form-group label="Select dashboard media node (Optional)" label-for="deviceTemplate"
              invalid-feedback="Please select management server for filter">
              <b-form-select id="dashboardMediaNode_3" class="languageWrapperSelect"
                v-model="addEditDeviceConfig.deviceFilter.dashboardMediaNode_3" style="width: 100%"
                :options="addEditDeviceConfig.deviceFilter.mediaNodes_3">
              </b-form-select>
            </b-form-group>
          </div>
          <div class="row m-0 align-items-center">
            <b-form-group label="Select device media node (Optional)" label-for="deviceTemplate"
              invalid-feedback="Please select management server for filter">
              <b-form-select id="deviceMediaNode_3" class="languageWrapperSelect"
                v-model="addEditDeviceConfig.deviceFilter.deviceMediaNode_3" style="width: 100%"
                :options="addEditDeviceConfig.deviceFilter.mediaNodes_3">
              </b-form-select>
            </b-form-group>
          </div>
        </b-card>
        <b-card class="card-container-panel">
          <h5 class="label_1_for_CIDR_CONF">Configuration 4 (Optional)</h5>
          <div class="row m-0 align-items-center">
            <b-form-group label="Select management server for filter *" label-for="deviceTemplate"
              invalid-feedback="Please select management server for filter">
              <b-form-select id="deviceTemplate" class="languageWrapperSelect"
                v-model="addEditDeviceConfig.deviceFilter.managementNode_4" style="width: 100%"
                :options="managementConfigList" @change="managementNodeSelected('4')">
              </b-form-select>
            </b-form-group>
          </div>
          <div class="row m-0 align-items-center">
            <b-form-group label="CIDR IP Address" label-for="nodeFilter"
              invalid-feedback="Please enter CIDR IP address.">
              <b-form-input id="cidrIpAdress_4" v-ip-mask
                v-model="addEditDeviceConfig.deviceFilter.cidrIPAddress_4"></b-form-input>
            </b-form-group>
          </div>
          <div class="row m-0 align-items-center">
            <b-form-group label="Select dashboard media node (Optional)" label-for="deviceTemplate"
              invalid-feedback="Please select management server for filter">
              <b-form-select id="dashboardMediaNode_4" class="languageWrapperSelect"
                v-model="addEditDeviceConfig.deviceFilter.dashboardMediaNode_4" style="width: 100%"
                :options="addEditDeviceConfig.deviceFilter.mediaNodes_4">
              </b-form-select>
            </b-form-group>
          </div>
          <div class="row m-0 align-items-center">
            <b-form-group label="Select device media node (Optional)" label-for="deviceTemplate"
              invalid-feedback="Please select management server for filter">
              <b-form-select id="deviceMediaNode_4" class="languageWrapperSelect"
                v-model="addEditDeviceConfig.deviceFilter.deviceMediaNode_4" style="width: 100%"
                :options="addEditDeviceConfig.deviceFilter.mediaNodes_4">
              </b-form-select>
            </b-form-group>
          </div>
        </b-card>
        <b-card class="card-container-panel">
          <h5 class="label_1_for_CIDR_CONF">Configuration 5 (Optional)</h5>
          <div class="row m-0 align-items-center">
            <b-form-group label="Select management server for filter *" label-for="deviceTemplate"
              invalid-feedback="Please select management server for filter">
              <b-form-select id="deviceTemplate" class="languageWrapperSelect"
                v-model="addEditDeviceConfig.deviceFilter.managementNode_5" style="width: 100%"
                :options="managementConfigList" @change="managementNodeSelected('5')">
              </b-form-select>
            </b-form-group>
          </div>
          <div class="row m-0 align-items-center">
            <b-form-group label="CIDR IP Address" label-for="nodeFilter"
              invalid-feedback="Please enter CIDR IP address.">
              <b-form-input id="cidrIpAdress_5" v-ip-mask
                v-model="addEditDeviceConfig.deviceFilter.cidrIPAddress_5"></b-form-input>
            </b-form-group>
          </div>
          <div class="row m-0 align-items-center">
            <b-form-group label="Select dashboard media node (Optional)" label-for="deviceTemplate"
              invalid-feedback="Please select management server for filter">
              <b-form-select id="dashboardMediaNode_5" class="languageWrapperSelect"
                v-model="addEditDeviceConfig.deviceFilter.dashboardMediaNode_5" style="width: 100%"
                :options="addEditDeviceConfig.deviceFilter.mediaNodes_5">
              </b-form-select>
            </b-form-group>
          </div>
          <div class="row m-0 align-items-center">
            <b-form-group label="Select device media node (Optional)" label-for="deviceTemplate"
              invalid-feedback="Please select management server for filter">
              <b-form-select id="deviceMediaNode_5" class="languageWrapperSelect"
                v-model="addEditDeviceConfig.deviceFilter.deviceMediaNode_5" style="width: 100%"
                :options="addEditDeviceConfig.deviceFilter.mediaNodes_5">
              </b-form-select>
            </b-form-group>
          </div>
        </b-card>
      </div>
    </b-form>
    <div v-if="!formValid" class="alert p-0"><b>{{ errorMessage }}</b></div>
    <template #modal-footer>
      <b-button variant="secondary" @click="showModal = false">Close</b-button>
      <b-button variant="primary" :disabled="!isValid()" @click="saveChanges">Save Changes</b-button>
    </template>
  </b-modal>
</template>

<script>
import { ModelSelect } from "vue-search-select";
import { tr } from "date-fns/locale";

export default {
  props: ['pexipMgtConfig', 'pexipDeviceConfig', 'staticConfiguration', 'lastSelectedTenant', "locationList",
    "defaultDeviceTypesForFilter", "devices", "selectedDeviceFilter"],
  components: {
    ModelSelect
  },
  data() {
    return {
      isReadyToShow: false,
      showModal: false,
      isNewFilterAdded: true,
      deviceTemplateList: [
        { text: 'By DeviceId', value: 'BY_DEVICE_ID' },
        { text: 'By Device Model only', value: 'BY_MODEL' },
        { text: 'By Facility and Device Model', value: 'BY_FACILITY_MODEL' },
        { text: 'By Facility / Location / Room', value: 'BY_FACILITY' },
      ],
      filterConfigList: [
        { text: 'Default config', value: 'BY_NON_IP_CIDR_ADDR' },
        { text: 'By IP CIDR config', value: 'BY_IP_CIDR_ADDR' },
      ],
      addEditDeviceConfig: {
        deviceTemplate: "BY_FACILITY",
        facility: "",
        unit: "",
        area: "",
        deviceId: "",
        deviceType: "",
        filterType: "BY_IP_CIDR_ADDR",
        deviceFilter: {
          cidrIPAddress_1: "",
          managementNode_1: "",
          dashboardMediaNode_1: "",
          deviceMediaNode_1: "",
          mediaNodes_1: [{ text: "Select media Node", value: "" }],
          cidrIPAddress_2: "",
          managementNode_2: "",
          dashboardMediaNode_2: "",
          deviceMediaNode_2: "",
          mediaNodes_2: [{ text: "Select media Node", value: "" }],
          cidrIPAddress_3: "",
          managementNode_3: "",
          dashboardMediaNode_3: "",
          deviceMediaNode_3: "",
          mediaNodes_3: [{ text: "Select media Node", value: "" }],
          cidrIPAddress_4: "",
          managementNode_4: "",
          dashboardMediaNode_4: "",
          deviceMediaNode_4: "",
          mediaNodes_4: [{ text: "Select media Node", value: "" }],
          cidrIPAddress_5: "",
          managementNode_5: "",
          dashboardMediaNode_5: "",
          deviceMediaNode_5: "",
          mediaNodes_5: [{ text: "Select media Node", value: "" }]
        }
      },
      formValid: true,
      errorMessage: "",
      facilityList: [{ text: 'Select Facility', value: '' }],
      unitList: [{ text: 'Select Unit', value: '' }],
      areaList: [{ text: 'Select Room', value: '' }],
      deviceTypes: [],
      deviceList: [],
      managementConfigList: [{ text: "Select management server", value: "" }],
      pexipMediaNodes: []
    };
  },
  directives: {
    'ip-mask': {
      bind(el) {
        el.addEventListener('input', (event) => {
          let value = event.target.value;
          value = value.replace(/[^0-9.//]/g, ''); // Allow only digits and dots
          const parts = value.split('.');

          if (parts.length > 4) {
            parts.length = 4; // Limit to 4 octets
          }

          for (let i = 0; i < parts.length; i++) {
            if (parts[i] !== '') {
              const num = parseInt(parts[i], 10);
              if (isNaN(num) || num < 0 || num > 255) {
                parts[i] = ''; // Invalid octet, clear it
              }
            }
          }

          event.target.value = parts.join('.');
          // event.target.dispatchEvent(new Event('input')); // Update v-model
        });
      },
    }
  },
  watch: {
    // errorMessage(newValue, oldValue) {
    //   console.log("errorMessage", newValue);
    // },
    async showModal(newVal) {
      if (newVal) {
        this.clearModel();
        this.addEditDeviceConfig.deviceTemplate = "BY_DEVICE_ID";
        this.addEditDeviceConfig.filterType = "BY_NON_IP_CIDR_ADDR";
        this.managementConfigList = [{ text: "Select management server", value: "" }];
        this.facilityList = this.locationList.map(l => {
          return {
            text: l.name,
            value: l.lId
          }
        });
        this.deviceTypes = this.defaultDeviceTypesForFilter.map(d => {
          return {
            text: d.type,
            value: d.id
          }
        });
        const devices = this.devices.map(d => {
          const deviceInfo = this.getLocationTaxonomy(d.location, d.unit, d.area);
          let deviceIdText = d.deviceId;
          let deviceLocationTxt = d.deviceId;
          if (deviceInfo) {
            deviceIdText = `${d.deviceId} -> ${deviceInfo.lName} / ${deviceInfo.uName} / ${deviceInfo.aName}`;
            deviceLocationTxt = `${deviceInfo.lName} / ${deviceInfo.uName} / ${deviceInfo.aName}`;
          }
          return {
            locationTxt: deviceLocationTxt,
            text: deviceIdText,
            value: d.deviceId,
          }
        });
        this.deviceList = devices.sort((a, b) => {
          return a.locationTxt.localeCompare(b.locationTxt);
        })

        this.managementConfigList = [...this.managementConfigList, ...this.pexipMgtConfig.map((m) => {
          return {
            text: `${m.key} - ${m.url}`,
            value: m.key
          }
        })];
        await this.getMediaNodes();
        this.selectedDeviceFilters();

        // console.log("showModal", this.addEditDeviceConfig.deviceFilter.mediaNodes_1);

        this.isReadyToShow = true;
      } else {
        this.isReadyToShow = false;
      }
    }
  },
  methods: {
    clearModel() {
      this.addEditDeviceConfig = {
        deviceTemplate: this.addEditDeviceConfig.deviceTemplate,
        facility: "",
        unit: "",
        area: "",
        deviceId: "",
        deviceType: "",
        filterType: this.addEditDeviceConfig.filterType,
        deviceFilter: {
          cidrIPAddress_1: "",
          managementNode_1: "",
          dashboardMediaNode_1: "",
          deviceMediaNode_1: "",
          mediaNodes_1: [{ text: "Select media Node", value: "" }],
          cidrIPAddress_2: "",
          managementNode_2: "",
          dashboardMediaNode_2: "",
          deviceMediaNode_2: "",
          mediaNodes_2: [{ text: "Select media Node", value: "" }],
          cidrIPAddress_3: "",
          managementNode_3: "",
          dashboardMediaNode_3: "",
          deviceMediaNode_3: "",
          mediaNodes_3: [{ text: "Select media Node", value: "" }],
          cidrIPAddress_4: "",
          managementNode_4: "",
          dashboardMediaNode_4: "",
          deviceMediaNode_4: "",
          mediaNodes_4: [{ text: "Select media Node", value: "" }],
          cidrIPAddress_5: "",
          managementNode_5: "",
          dashboardMediaNode_5: "",
          deviceMediaNode_5: "",
          mediaNodes_5: [{ text: "Select media Node", value: "" }]
        },
        managementConfigList: [{ text: "Select management server", value: "" }],
      };
      this.formValid = true;
      this.errorMessage = "";
    },
    selectedDeviceFilters() {
      if (this.selectedDeviceFilter) {
        const deviceFilter = this.pexipDeviceConfig.find(d => d.filterKey === this.selectedDeviceFilter);
        if (deviceFilter) {
          this.addEditDeviceConfig.deviceTemplate = deviceFilter.filterTemplate;
          if (deviceFilter.locationId) this.addEditDeviceConfig.facility = deviceFilter.locationId;
          this.facilitySelected();
          if (deviceFilter.unitId) this.addEditDeviceConfig.unit = deviceFilter.unitId;
          this.unitSelected();
          if (deviceFilter.areaId) this.addEditDeviceConfig.area = deviceFilter.areaId;
          if (deviceFilter.deviceId) this.addEditDeviceConfig.deviceId = deviceFilter.deviceId;
          if (deviceFilter.deviceTypeId) this.addEditDeviceConfig.deviceType = deviceFilter.deviceTypeId;
          if (deviceFilter.configs && deviceFilter.configs.length > 0) {
            this.addEditDeviceConfig.filterType = "BY_IP_CIDR_ADDR";
            if (deviceFilter.configs[0].ip_cidr) this.addEditDeviceConfig.deviceFilter.cidrIPAddress_1 = deviceFilter.configs[0].ip_cidr;
            if (deviceFilter.configs[0].key) this.addEditDeviceConfig.deviceFilter.managementNode_1 = deviceFilter.configs[0].key;
            this.managementNodeSelected('1');
            if (deviceFilter.configs[0].deviceMediaNode) this.addEditDeviceConfig.deviceFilter.deviceMediaNode_1 = deviceFilter.configs[0].deviceMediaNode;
            if (deviceFilter.configs[0].dashboardMediaNode) this.addEditDeviceConfig.deviceFilter.dashboardMediaNode_1 = deviceFilter.configs[0].dashboardMediaNode;

            if (deviceFilter.configs.length > 1) {
              if (deviceFilter.configs[1].ip_cidr) this.addEditDeviceConfig.deviceFilter.cidrIPAddress_2 = deviceFilter.configs[1].ip_cidr;
              if (deviceFilter.configs[1].key) this.addEditDeviceConfig.deviceFilter.managementNode_2 = deviceFilter.configs[1].key;
              this.managementNodeSelected('2');
              if (deviceFilter.configs[1].deviceMediaNode) this.addEditDeviceConfig.deviceFilter.deviceMediaNode_2 = deviceFilter.configs[1].deviceMediaNode;
              if (deviceFilter.configs[1].dashboardMediaNode) this.addEditDeviceConfig.deviceFilter.dashboardMediaNode_2 = deviceFilter.configs[1].dashboardMediaNode;
            }
            if (deviceFilter.configs.length > 2) {
              if (deviceFilter.configs[2].ip_cidr) this.addEditDeviceConfig.deviceFilter.cidrIPAddress_3 = deviceFilter.configs[2].ip_cidr;
              if (deviceFilter.configs[2].key) this.addEditDeviceConfig.deviceFilter.managementNode_3 = deviceFilter.configs[2].key;
              this.managementNodeSelected('3');
              if (deviceFilter.configs[2].deviceMediaNode) this.addEditDeviceConfig.deviceFilter.deviceMediaNode_3 = deviceFilter.configs[2].deviceMediaNode;
              if (deviceFilter.configs[2].dashboardMediaNode) this.addEditDeviceConfig.deviceFilter.dashboardMediaNode_3 = deviceFilter.configs[2].dashboardMediaNode;
            }
            if (deviceFilter.configs.length > 3) {
              if (deviceFilter.configs[3].ip_cidr) this.addEditDeviceConfig.deviceFilter.cidrIPAddress_4 = deviceFilter.configs[3].ip_cidr;
              if (deviceFilter.configs[3].key) this.addEditDeviceConfig.deviceFilter.managementNode_4 = deviceFilter.configs[3].key;
              this.managementNodeSelected('4');
              if (deviceFilter.configs[3].deviceMediaNode) this.addEditDeviceConfig.deviceFilter.deviceMediaNode_4 = deviceFilter.configs[3].deviceMediaNode;
              if (deviceFilter.configs[3].dashboardMediaNode) this.addEditDeviceConfig.deviceFilter.dashboardMediaNode_4 = deviceFilter.configs[3].dashboardMediaNode;
            }
            if (deviceFilter.configs.length > 4) {
              if (deviceFilter.configs[4].ip_cidr) this.addEditDeviceConfig.deviceFilter.cidrIPAddress_5 = deviceFilter.configs[4].ip_cidr;
              if (deviceFilter.configs[4].key) this.addEditDeviceConfig.deviceFilter.managementNode_5 = deviceFilter.configs[4].key;
              this.managementNodeSelected('5');
              if (deviceFilter.configs[4].deviceMediaNode) this.addEditDeviceConfig.deviceFilter.deviceMediaNode_5 = deviceFilter.configs[4].deviceMediaNode;
              if (deviceFilter.configs[4].dashboardMediaNode) this.addEditDeviceConfig.deviceFilter.dashboardMediaNode_5 = deviceFilter.configs[4].dashboardMediaNode;
            }
          }
          if (deviceFilter.config) {
            this.addEditDeviceConfig.filterType = "BY_NON_IP_CIDR_ADDR";
            if (deviceFilter.config.ip_cidr) this.addEditDeviceConfig.deviceFilter.cidrIPAddress_1 = deviceFilter.config.ip_cidr;
            if (deviceFilter.config.key) this.addEditDeviceConfig.deviceFilter.managementNode_1 = deviceFilter.config.key;
            this.managementNodeSelected('1');
            if (deviceFilter.config.deviceMediaNode) this.addEditDeviceConfig.deviceFilter.deviceMediaNode_1 = deviceFilter.config.deviceMediaNode
            if (deviceFilter.config.dashboardMediaNode) this.addEditDeviceConfig.deviceFilter.dashboardMediaNode_1 = deviceFilter.config.dashboardMediaNode;
          }

          // console.log("showModal", JSON.stringify(deviceFilter));
          // console.log("showModal", JSON.stringify(this.addEditDeviceConfig));
        }
        this.isNewFilterAdded = false;
      }
    },
    managementNodeSelected(confIndex) {
      const mgtNodeSelected = this.addEditDeviceConfig.deviceFilter[`managementNode_${confIndex}`];
      this.addEditDeviceConfig.deviceFilter[`mediaNodes_${confIndex}`] = [{ text: "Select media Node", value: "" }];
      this.addEditDeviceConfig.deviceFilter[`dashboardMediaNode_${confIndex}`] = "";
      this.addEditDeviceConfig.deviceFilter[`deviceMediaNode_${confIndex}`] = "";
      if (mgtNodeSelected && this.pexipMediaNodes.length > 0) {
        const mediaNodeByServer = this.pexipMediaNodes.find(m => m.key === mgtNodeSelected);
        if (mediaNodeByServer && mediaNodeByServer.mediaNodes && mediaNodeByServer.mediaNodes.length > 0) {
          this.addEditDeviceConfig.deviceFilter[`mediaNodes_${confIndex}`] = [...this.addEditDeviceConfig.deviceFilter[`mediaNodes_${confIndex}`], ...mediaNodeByServer.mediaNodes.map(m => {
            return {
              text: m.nodeName,
              value: m.nodeName
            }
          })];
        }
      }
    },
    async getMediaNodes() {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var url = config.OPERATIONS_SERVICE + `/tenants/${this.lastSelectedTenant}/available-media-nodes`;
      var pexipMediaNodeRequest = new Request(url, {
        method: "GET",
        mode: "cors",
        withCredentials: true,
        credentials: "include",
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json"
        }
      });

      try {
        var pexipMediaNodeResponse = await fetch(pexipMediaNodeRequest);
        if (pexipMediaNodeResponse.status === 503) {
          return this.getMediaNodes();
        }
        this.pexipMediaNodes = await pexipMediaNodeResponse.json();
      } catch (error) {
        console.error(error);
      }
    },
    facilitySelected() {
      if (this.addEditDeviceConfig.facility) {
        const selectedFacility = this.locationList.find(l => l.lId === this.addEditDeviceConfig.facility);
        if (selectedFacility) {
          this.unitList = selectedFacility.units.map(u => {
            return {
              text: u.name,
              value: u.uId
            }
          });
        }
      }
    },
    getLocationTaxonomy(lId, uId, aId) {
      const location = this.locationList.find(l => l.lId === lId);
      if (location) {
        const unit = location.units.find(u => u.uId === uId);
        if (unit) {
          const area = unit.areas.find(u => u.aId === aId);
          if (area) {
            return {
              lId: location.lId,
              lName: location.name,
              uId: unit.uId,
              uName: unit.name,
              aId: area.aId,
              aName: area.name
            }
          }
        }
      }
      return null;
    },
    unitSelected() {
      if (this.addEditDeviceConfig.facility) {
        const selectedFacility = this.locationList.find(l => l.lId === this.addEditDeviceConfig.facility);
        if (selectedFacility && this.addEditDeviceConfig.unit) {
          const unitSelected = selectedFacility.units.find(u => u.uId === this.addEditDeviceConfig.unit);
          if (unitSelected) {
            this.areaList = unitSelected.areas.map(a => {
              return {
                text: a.name,
                value: a.aId
              }
            })
          }
        }
      }
    },
    areaSelected() {

    },
    deviceIdSelected() { },
    async saveChanges() {
      this.formValid = true;
      this.errorMessage = "";
      // Handle saving changes here
      if (this.isValid()) {
        if (!this.isFilterDuplicate()) {
          this.saveDeviceFilter();
        } else {
          this.formValid = false;
          this.errorMessage = "There is already a filter matching this criteria. Please close & edit the same.";
        }
      }
    },
    build_update_request() {
      let filterKey;
      if (this.addEditDeviceConfig.deviceTemplate === "BY_DEVICE_ID") filterKey = `${this.addEditDeviceConfig.deviceId}_filter`;
      else if (this.addEditDeviceConfig.deviceTemplate === "BY_MODEL") filterKey = `${this.addEditDeviceConfig.deviceType}_filter`;
      else if (this.addEditDeviceConfig.deviceTemplate === "BY_FACILITY_MODEL") {
        if (this.addEditDeviceConfig.area) {
          filterKey = `${this.addEditDeviceConfig.facility}_${this.addEditDeviceConfig.unit}_${this.addEditDeviceConfig.area}_${this.addEditDeviceConfig.deviceType}_filter`;
        } else if (this.addEditDeviceConfig.unit) {
          filterKey = `${this.addEditDeviceConfig.facility}_${this.addEditDeviceConfig.unit}_${this.addEditDeviceConfig.deviceType}_filter`;
        } else {
          filterKey = `${this.addEditDeviceConfig.facility}_${this.addEditDeviceConfig.deviceType}_filter`;
        }
      }
      else if (this.addEditDeviceConfig.deviceTemplate === "BY_FACILITY") {
        if (this.addEditDeviceConfig.area) {
          filterKey = `${this.addEditDeviceConfig.facility}_${this.addEditDeviceConfig.unit}_${this.addEditDeviceConfig.area}_filter`;
        } else if (this.addEditDeviceConfig.unit) {
          filterKey = `${this.addEditDeviceConfig.facility}_${this.addEditDeviceConfig.unit}_filter`;
        } else {
          filterKey = `${this.addEditDeviceConfig.facility}_filter`;
        }
      }
      let filterValue;
      if (this.addEditDeviceConfig.filterType === "BY_IP_CIDR_ADDR") {
        filterValue = [];
        filterValue.push({
          management_node: this.addEditDeviceConfig.deviceFilter.managementNode_1,
          ...(this.addEditDeviceConfig.deviceFilter.cidrIPAddress_1 && { ip_cidr: this.addEditDeviceConfig.deviceFilter.cidrIPAddress_1 }),
          ...(this.addEditDeviceConfig.deviceFilter.dashboardMediaNode_1 && { dashboardMediaNode: this.addEditDeviceConfig.deviceFilter.dashboardMediaNode_1 }),
          ...(this.addEditDeviceConfig.deviceFilter.deviceMediaNode_1 && { deviceMediaNode: this.addEditDeviceConfig.deviceFilter.deviceMediaNode_1 }),
        })
        if (this.addEditDeviceConfig.deviceFilter.managementNode_2) {
          filterValue.push({
            management_node: this.addEditDeviceConfig.deviceFilter.managementNode_2,
            ...(this.addEditDeviceConfig.deviceFilter.cidrIPAddress_2 && { ip_cidr: this.addEditDeviceConfig.deviceFilter.cidrIPAddress_2 }),
            ...(this.addEditDeviceConfig.deviceFilter.dashboardMediaNode_2 && { dashboardMediaNode: this.addEditDeviceConfig.deviceFilter.dashboardMediaNode_2 }),
            ...(this.addEditDeviceConfig.deviceFilter.deviceMediaNode_2 && { deviceMediaNode: this.addEditDeviceConfig.deviceFilter.deviceMediaNode_2 }),
          })
        }
        if (this.addEditDeviceConfig.deviceFilter.managementNode_3) {
          filterValue.push({
            management_node: this.addEditDeviceConfig.deviceFilter.managementNode_3,
            ...(this.addEditDeviceConfig.deviceFilter.cidrIPAddress_3 && { ip_cidr: this.addEditDeviceConfig.deviceFilter.cidrIPAddress_3 }),
            ...(this.addEditDeviceConfig.deviceFilter.dashboardMediaNode_3 && { dashboardMediaNode: this.addEditDeviceConfig.deviceFilter.dashboardMediaNode_3 }),
            ...(this.addEditDeviceConfig.deviceFilter.deviceMediaNode_3 && { deviceMediaNode: this.addEditDeviceConfig.deviceFilter.deviceMediaNode_3 }),
          })
        }
        if (this.addEditDeviceConfig.deviceFilter.managementNode_4) {
          filterValue.push({
            management_node: this.addEditDeviceConfig.deviceFilter.managementNode_4,
            ...(this.addEditDeviceConfig.deviceFilter.cidrIPAddress_4 && { ip_cidr: this.addEditDeviceConfig.deviceFilter.cidrIPAddress_4 }),
            ...(this.addEditDeviceConfig.deviceFilter.dashboardMediaNode_4 && { dashboardMediaNode: this.addEditDeviceConfig.deviceFilter.dashboardMediaNode_4 }),
            ...(this.addEditDeviceConfig.deviceFilter.deviceMediaNode_4 && { deviceMediaNode: this.addEditDeviceConfig.deviceFilter.deviceMediaNode_4 }),
          })
        }
        if (this.addEditDeviceConfig.deviceFilter.managementNode_5) {
          filterValue.push({
            management_node: this.addEditDeviceConfig.deviceFilter.managementNode_5,
            ...(this.addEditDeviceConfig.deviceFilter.cidrIPAddress_5 && { ip_cidr: this.addEditDeviceConfig.deviceFilter.cidrIPAddress_5 }),
            ...(this.addEditDeviceConfig.deviceFilter.dashboardMediaNode_5 && { dashboardMediaNode: this.addEditDeviceConfig.deviceFilter.dashboardMediaNode_5 }),
            ...(this.addEditDeviceConfig.deviceFilter.deviceMediaNode_5 && { deviceMediaNode: this.addEditDeviceConfig.deviceFilter.deviceMediaNode_5 }),
          })
        }
      } else {
        filterValue = {
          management_node: this.addEditDeviceConfig.deviceFilter.managementNode_1,
          ...(this.addEditDeviceConfig.deviceFilter.cidrIPAddress_1 && { ip_cidr: this.addEditDeviceConfig.deviceFilter.cidrIPAddress_1 }),
          ...(this.addEditDeviceConfig.deviceFilter.dashboardMediaNode_1 && { dashboardMediaNode: this.addEditDeviceConfig.deviceFilter.dashboardMediaNode_1 }),
          ...(this.addEditDeviceConfig.deviceFilter.deviceMediaNode_1 && { deviceMediaNode: this.addEditDeviceConfig.deviceFilter.deviceMediaNode_1 }),
        }
      }
      let request_body = {};
      request_body[filterKey] = filterValue;
      return request_body;
    },
    async saveDeviceFilter() {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var url = config.OPERATIONS_SERVICE + `/tenants/${this.lastSelectedTenant}/virtual-media-info`;
      var pexipDeviceFilterRequest = new Request(url, {
        method: "PUT",
        mode: "cors",
        withCredentials: true,
        credentials: "include",
        body: JSON.stringify(this.build_update_request()),
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json"
        }
      });

      try {
        var savePexipManagementResponse = await fetch(pexipDeviceFilterRequest);
        if (savePexipManagementResponse.status === 503) {
          return this.saveManagementServer();
        }
        if (savePexipManagementResponse.status === 200) {
          this.formValid = false;
          this.isReadyToShow = false;
          this.showModal = false;
          this.$emit('deviceFilterSaved');
        }
        const savePexipManagementResponseBody = await savePexipManagementResponse.json();
        this.errorMessage = "Failed to save the Pexip Management Server with Error"
        if (savePexipManagementResponse.status === 400 && savePexipManagementResponseBody.error) {
          const errorMessage = savePexipManagementResponseBody.error;
          if (errorMessage) {
            const errorMessageTemp = errorMessage.split(':');
            if (errorMessageTemp.length > 0) {
              this.errorMessage = errorMessageTemp[1];
            }
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    isFilterDuplicate() {
      if (this.isNewFilterAdded) {
        const checkIfFilterExists = (filterKey) => {
          if (this.pexipDeviceConfig && Array.isArray(this.pexipDeviceConfig) && this.pexipDeviceConfig.length > 0) {
            if (this.pexipDeviceConfig.filter(d => d.filterKey === filterKey).length > 0) {
              return true;
            }
          }
          return false;
        }

        if (this.addEditDeviceConfig.deviceTemplate === "BY_DEVICE_ID") {
          return checkIfFilterExists(this.addEditDeviceConfig.deviceId)
        }
        if (this.addEditDeviceConfig.deviceTemplate === "BY_MODEL") {
          return checkIfFilterExists(this.addEditDeviceConfig.deviceType)
        }
        if (this.addEditDeviceConfig.deviceTemplate === "BY_FACILITY_MODEL") {
          if (this.addEditDeviceConfig.unit && this.addEditDeviceConfig.area) return checkIfFilterExists(`${this.addEditDeviceConfig.facility}_${this.addEditDeviceConfig.unit}_${this.addEditDeviceConfig.area}_${this.addEditDeviceConfig.deviceType}`)
          if (this.addEditDeviceConfig.unit) return checkIfFilterExists(`${this.addEditDeviceConfig.facility}_${this.addEditDeviceConfig.unit}_${this.addEditDeviceConfig.deviceType}`)
          else return checkIfFilterExists(`${this.addEditDeviceConfig.facility}_${this.addEditDeviceConfig.deviceType}`)
        }
        if (this.addEditDeviceConfig.deviceTemplate === "BY_FACILITY") {
          if (this.addEditDeviceConfig.unit && this.addEditDeviceConfig.area) return checkIfFilterExists(`${this.addEditDeviceConfig.facility}_${this.addEditDeviceConfig.unit}_${this.addEditDeviceConfig.area}`)
          else if (this.addEditDeviceConfig.unit) return checkIfFilterExists(`${this.addEditDeviceConfig.facility}_${this.addEditDeviceConfig.unit}`)
          else return checkIfFilterExists(`${this.addEditDeviceConfig.facility}`)
        }
      }
      return false;
    },
    isValid() {
      if (this.addEditDeviceConfig.deviceTemplate === "BY_DEVICE_ID") {
        if (!this.addEditDeviceConfig.deviceId) {
          this.errorMessage = "DeviceId is required."
          return false;
        }
      }
      if (this.addEditDeviceConfig.deviceTemplate === "BY_MODEL") {
        if (!this.addEditDeviceConfig.deviceType) {
          this.errorMessage = "Device Model is required."
          return false;
        }
      }
      if (this.addEditDeviceConfig.deviceTemplate === "BY_FACILITY_MODEL") {
        if (!this.addEditDeviceConfig.deviceType || !this.addEditDeviceConfig.facility) {
          this.errorMessage = "Device Model & Facility is required."
          return false;
        }
      }
      if (this.addEditDeviceConfig.deviceTemplate === "BY_FACILITY") {
        if (!this.addEditDeviceConfig.facility) {
          this.errorMessage = "Facility is required."
          return false;
        }
      }
      if (this.addEditDeviceConfig.filterType === "BY_NON_IP_CIDR_ADDR") {
        return this.checkForParamsForNONCIDRRequest();
      }
      if (this.addEditDeviceConfig.filterType === "BY_IP_CIDR_ADDR") {
        return this.checkForParamsForCIDRRequest();
      }
      return true;
    },
    checkForParamsForCIDRRequest() {
      if (!this.addEditDeviceConfig.deviceFilter.cidrIPAddress_1 || !this.addEditDeviceConfig.deviceFilter.managementNode_1) {
        this.errorMessage = "CIDR IP Address & Management Node is required."
        return false;
      }
      if ((this.addEditDeviceConfig.deviceFilter.managementNode_2 || this.addEditDeviceConfig.deviceFilter.cidrIPAddress_2)
        && (!this.addEditDeviceConfig.deviceFilter.managementNode_2 || !this.addEditDeviceConfig.deviceFilter.cidrIPAddress_2)) {
        this.errorMessage = "CIDR IP Address 2 & Management Node 2 is required."
        return false;
      }
      if ((this.addEditDeviceConfig.deviceFilter.managementNode_3 || this.addEditDeviceConfig.deviceFilter.cidrIPAddress_3)
        && (!this.addEditDeviceConfig.deviceFilter.managementNode_3 || !this.addEditDeviceConfig.deviceFilter.cidrIPAddress_3)) {
        this.errorMessage = "CIDR IP Address 3 & Management Node 3 is required."
        return false;
      }
      if ((this.addEditDeviceConfig.deviceFilter.managementNode_4 || this.addEditDeviceConfig.deviceFilter.cidrIPAddress_4)
        && (!this.addEditDeviceConfig.deviceFilter.managementNode_4 || !this.addEditDeviceConfig.deviceFilter.cidrIPAddress_4)) {
        this.errorMessage = "CIDR IP Address 4 & Management Node 4 is required."
        return false;
      }
      if ((this.addEditDeviceConfig.deviceFilter.managementNode_5 || this.addEditDeviceConfig.deviceFilter.cidrIPAddress_5)
        && (!this.addEditDeviceConfig.deviceFilter.managementNode_5 || !this.addEditDeviceConfig.deviceFilter.cidrIPAddress_5)) {
        this.errorMessage = "CIDR IP Address 5 & Management Node 5 is required."
        return false;
      }
      return true;
    },
    checkForParamsForNONCIDRRequest() {
      // console.log("isValid -", this.addEditDeviceConfig.deviceFilter.cidrIPAddress_1, this.addEditDeviceConfig.deviceFilter.managementNode_1)
      if (!this.addEditDeviceConfig.deviceFilter.managementNode_1) {
        this.errorMessage = "CIDR IP Address 1 & Management Node 1 is required."
        return false;
      }
      return true;
    }
  },
};
</script>

<style lang="scss">
.modal-dialog {
  max-width: 46%;
  margin: 2.15rem auto;
}
</style>

<style lang="scss" scoped>
.alert {
  color: #d43d3d;
}

.dropdown .dropdown-content {
  max-width: 600px;
  min-width: 600px;
  margin-top: 5px;
}

.dropdown:before {
  content: "";
  border: solid #8e8e8e;
  border-width: 0 1px 1px 0;
  display: inline-block;
  padding: 3px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  position: absolute;
  right: 15px;
  top: 15px;
}

.dropdown.searchableSelect .dropdown-input {
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 90%;
  overflow: hidden;
  min-width: auto;
}

.searchableSelect {
  width: 600px;
  min-width: 600px;
}

.dropdown .searchableSelect {
  width: 100%;
  min-width: 800px;
  border: 1px solid rgba(34, 36, 38, .15) !important;
}

.label_1_for_CIDR_CONF {
  color: #3288D2;
}

.pageDataWrapper {
  padding: 0;
}

.mt-20 {
  margin-top: 20px;
}
</style>/